import {connect} from "react-redux"
import State from "../../models/state"
import {getToolTipTitleByType, formatTitle} from "../../utils/colourwayBuilders"
import {BundleType, SuitType} from "../../config/constants"

export const mapStateToProps = (state: State) => {
    const {
        productSummary: {
            summaryData: {title: defaultTitle, colourways, type, department, fit},
            enabledSearchDesc,
        },
        request: {isEnglishLang},
        text: {
            labels: {rating},
        },
    } = state

    const selectedColourway = colourways.find(colourway => colourway.s) as any
    const colourWaysHasValidStarRating = colourways.some(colourway => colourway?.st)

    const colourwaysHasPriceRangeAndStarRatings = colourWaysHasValidStarRating
        ? colourways.some(colourway => colourway?.p.split("-").length === 2)
        : false

    const textTitle = enabledSearchDesc
        ? selectedColourway?.t || ""
        : formatTitle({
              title: defaultTitle,
              selectedColourway,
              fit,
              department,
              isEnglishLang,
          })
    return {
        overallStarRating: selectedColourway.st || 0,
        colourwaysHasPriceRangeAndStarRatings,
        tooltipTitle: getToolTipTitleByType(type, {
            title: selectedColourway.t,
            defaultTitle: type === SuitType || type === BundleType ? defaultTitle : textTitle,
            colourwayItemNumber: selectedColourway.id,
            price: selectedColourway.p,
            salePrice: selectedColourway.sp,
            fit,
            selectedColourway,
            isEnglishLang,
        }),
        ratingText: rating,
    }
}

export default connect(mapStateToProps)
